"use client";
import * as Sentry from "@sentry/nextjs";
import Error from "next/error";
import { Geist, Geist_Mono } from "next/font/google";
import { useEffect } from "react";

import "@/app/globals.css";

import { ErrorState } from "@/components/error/ErrorState";

const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"],
});

const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"],
});

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    console.error(error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body className={`${geistSans.variable} ${geistMono.variable} bg-background text-foreground`}>
        <ErrorState
          title="We are working on it"
          description="Something unexpected just happened."
          details={
            <p>
              Please refresh the page in a moment. If this keeps happening, reach out to our team so
              we can fix it quickly.
            </p>
          }
          actions={[
            {
              label: "Reload page",
              onClick: () => window.location.reload(),
            },
            {
              label: "Go to home",
              href: "/",
              variant: "ghost",
            },
          ]}
        />
      </body>
    </html>
  );
}
